<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="800"
    scrollable
  >
    <v-card class="pa-2">
      <v-card-title class="caption">
        <h2>{{$_strings.mou.DATA_HISTORY}}</h2>
      </v-card-title>
      <v-card-text class="mt-4">
        <v-row>
          <v-col>
            <h3>{{$_strings.mou.PREVIOUS_DATA}}</h3>
            <FormCooperationInformationVue :type="type" :form="formMouPrevVersion"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3>{{$_strings.mou.LATEST_DATA}}</h3>
            <FormCooperationInformationVue :type="type" :form="form"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="d-flex justify-center"
      >
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn
              color="primary"
              small
              class="white--text mr-4"
              @click="dialog = false"
            >
              Ok
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FormCooperationInformationVue from './FormCooperationInformation.vue';

export default {
  components: {
    FormCooperationInformationVue,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    formMouPrevVersion: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      type: '',
    };
  },
  watch: {
    dialog(newVal) {
    },
  },
};
</script>
